export default __webpack_public_path__ + "static/media/calc-photo.4fb26fbc.png";